export function makeStartDrag(agentElId) {
  return function startDrag(e, onMove) {
    e.preventDefault();
    var handle = e.currentTarget;
    handle.setPointerCapture(e.pointerId);
    var agentEl = document.getElementById(agentElId);
    if (agentEl) agentEl.style.pointerEvents = 'none';
    function onUp() {
      handle.removeEventListener('pointermove', onMove);
      handle.removeEventListener('pointerup', onUp);
      handle.removeEventListener('pointercancel', onUp);
      handle.removeEventListener('lostpointercapture', onUp);
      if (agentEl) agentEl.style.pointerEvents = '';
    }
    handle.addEventListener('pointermove', onMove);
    handle.addEventListener('pointerup', onUp);
    handle.addEventListener('pointercancel', onUp);
    handle.addEventListener('lostpointercapture', onUp);
  };
}